var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.balance)?_c('div',{staticClass:"token-balance-block dumbapp-block"},[_c('div',{staticClass:"token-balance-heading"},[_vm._v(" Your Token Balance ")]),_c('TokenAmount',{attrs:{"value":_vm.balance,"symbol":_vm.context.contract.parameters.symbol,"decimals":_vm.context.contract.parameters.decimals}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }